const graphqlUrl =
  process.env.GATSBY_MUTATION_URL ??
  'https://trade-direct-insurance.uksouth01.umbraco.io/graphql';

/**
 * Ensures relative /media/ URLs in HTML content are prefixed with the
 * Umbraco base URL so they resolve correctly everywhere.
 *
 * Umbraco's GraphQL API returns absolute media URLs for top-level Rich Text
 * properties but relative paths for rich text inside nested/element types
 * (e.g. accordion items). This normalises both cases.
 *
 * @param {string} content - The HTML string to process.
 * @returns {string} - The HTML with absolute media URLs.
 */
export const resolveMediaUrls = (content: string): string => {
  if (!content || typeof content !== 'string') {
    return content;
  }

  const { protocol, host } = new URL(graphqlUrl);

  return content.replace(
    /(href|src)=(["'])(\/media\/)/gi,
    `$1=$2${protocol}//${host}$3`
  );
};
